type IconProps = React.HTMLAttributes<SVGElement>;

export const Icons = {
  Spinner: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
  Info: (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 0C9.75 0.03125 7.73438 0.578125 5.95312 1.64062C4.14062 2.70312 2.70312 4.14062 1.64062 5.95312C0.578125 7.73438 0.03125 9.75 0 12C0.03125 14.25 0.578125 16.2656 1.64062 18.0469C2.70312 19.8594 4.14062 21.2969 5.95312 22.3594C7.73438 23.4219 9.75 23.9688 12 24C14.25 23.9688 16.2656 23.4219 18.0469 22.3594C19.8594 21.2969 21.2969 19.8594 22.3594 18.0469C23.4219 16.2656 23.9688 14.25 24 12C23.9688 9.75 23.4219 7.73438 22.3594 5.95312C21.2969 4.14062 19.8594 2.70312 18.0469 1.64062C16.2656 0.578125 14.25 0.03125 12 0ZM12 21.75C9.25 21.6875 6.95312 20.7344 5.10938 18.8906C3.26562 17.0469 2.3125 14.75 2.25 12C2.3125 9.25 3.26562 6.95312 5.10938 5.10938C6.95312 3.26562 9.25 2.3125 12 2.25C14.75 2.3125 17.0469 3.26562 18.8906 5.10938C20.7344 6.95312 21.6875 9.25 21.75 12C21.6875 14.75 20.7344 17.0469 18.8906 18.8906C17.0469 20.7344 14.75 21.6875 12 21.75ZM13.875 15.75H13.125V11.625C13.0625 10.9375 12.6875 10.5625 12 10.5H10.5C9.8125 10.5625 9.4375 10.9375 9.375 11.625C9.4375 12.3125 9.8125 12.6875 10.5 12.75H10.875V15.75H10.125C9.4375 15.8125 9.0625 16.1875 9 16.875C9.0625 17.5625 9.4375 17.9375 10.125 18H13.875C14.5625 17.9375 14.9375 17.5625 15 16.875C14.9375 16.1875 14.5625 15.8125 13.875 15.75ZM12 9C12.4375 9 12.7969 8.85938 13.0781 8.57812C13.3594 8.29688 13.5 7.9375 13.5 7.5C13.5 7.0625 13.3594 6.70312 13.0781 6.42188C12.7969 6.14062 12.4375 6 12 6C11.5625 6 11.2031 6.14062 10.9219 6.42188C10.6406 6.70312 10.5 7.0625 10.5 7.5C10.5 7.9375 10.6406 8.29688 10.9219 8.57812C11.2031 8.85938 11.5625 9 12 9Z"
        fill="#A1A1AA"
      />
    </svg>
  ),
  Wand: (props: any) => (
    <svg
      width={props.width ?? "24"}
      height={props.width ?? "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.17185 7.02776L3.14242 6.73792C3.06247 6.71793 3.0025 6.63798 3.0025 6.55802C3.0025 6.47807 3.06247 6.39811 3.14242 6.37812L4.17185 6.08828C5.11133 5.81843 5.84093 5.08884 6.11078 4.14936L6.40061 3.11993C6.44059 2.96002 6.71044 2.96002 6.76041 3.11993L7.05025 4.14936C7.3201 5.09883 8.0497 5.81843 8.98918 6.08828L10.0186 6.37812C10.0986 6.39811 10.1585 6.47807 10.1585 6.55802C10.1585 6.63798 10.0986 6.71793 10.0186 6.73792L8.98918 7.02776C8.0497 7.29761 7.3201 8.02721 7.05025 8.96669L6.76041 9.99611C6.74043 10.0761 6.66047 10.136 6.58051 10.136C6.50056 10.136 6.4206 10.0761 6.40061 9.99611L6.11078 8.96669C5.84093 8.01721 5.11133 7.29761 4.17185 7.02776ZM17.8842 3.7296L20.2629 6.10827C20.5727 6.4181 20.5727 6.92782 20.2629 7.23765L6.74042 20.7601C6.43059 21.07 5.92088 21.07 5.61105 20.7601L3.23237 18.3815C2.92254 18.0716 2.92254 17.5619 3.23237 17.2521L16.7549 3.7296C17.0647 3.41977 17.5744 3.41977 17.8842 3.7296ZM12.977 9.8462L14.1463 11.0155L18.4939 6.66796L17.3245 5.49861L12.977 9.8462ZM20.8726 15.0833L19.9331 14.8134C19.0736 14.5636 18.4139 13.9039 18.1641 13.0444L17.8942 12.1049C17.8542 11.955 17.6044 11.955 17.5644 12.1049L17.2946 13.0444C17.0447 13.9039 16.3851 14.5736 15.5255 14.8134L14.5861 15.0833C14.5161 15.1033 14.4661 15.1732 14.4661 15.2532C14.4661 15.3331 14.5161 15.3931 14.5861 15.4231L15.5255 15.6929C16.3851 15.9428 17.0447 16.6024 17.2946 17.462L17.5644 18.4014C17.5844 18.4714 17.6544 18.5214 17.7343 18.5214C17.8143 18.5214 17.8742 18.4714 17.9042 18.4014L18.1741 17.462C18.4239 16.6024 19.0836 15.9428 19.9431 15.6929L20.8826 15.4231C20.9525 15.4031 21.0025 15.3331 21.0025 15.2532C21.0025 15.1732 20.9525 15.1133 20.8826 15.0833H20.8726ZM14.2363 17.6019C14.3962 18.1416 14.8059 18.5514 15.3357 18.7013L15.9153 18.8712C15.9653 18.8812 15.9953 18.9212 15.9953 18.9711C15.9953 19.0211 15.9153 19.0711 15.9153 19.0711L15.3357 19.241C14.796 19.4009 14.3862 19.8107 14.2363 20.3404L14.0664 20.92C14.0564 20.97 14.0164 21 13.9664 21C13.9164 21 13.8665 20.92 13.8665 20.92L13.6966 20.3404C13.5367 19.8007 13.1269 19.3909 12.5972 19.241L12.0175 19.0711C11.9675 19.0611 11.9375 19.0211 11.9375 18.9711C11.9375 18.9212 12.0175 18.8712 12.0175 18.8712L12.5972 18.7013C13.1369 18.5414 13.5466 18.1316 13.6966 17.6019L13.8665 17.0222C13.8865 16.9323 14.0364 16.9323 14.0664 17.0222L14.2363 17.6019Z"
        fill="#223C69"
        {...props}
      />
    </svg>
  ),
  CheckFilled: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22ZM16.6337 10.3837C16.8614 10.148 16.9874 9.83224 16.9846 9.5045C16.9817 9.17675 16.8503 8.86324 16.6185 8.63148C16.3868 8.39972 16.0732 8.26826 15.7455 8.26541C15.4178 8.26256 15.102 8.38855 14.8663 8.61625L10.75 12.7325L9.13375 11.1163C8.898 10.8886 8.58224 10.7626 8.2545 10.7654C7.92675 10.7683 7.61324 10.8997 7.38148 11.1315C7.14972 11.3632 7.01826 11.6768 7.01541 12.0045C7.01256 12.3322 7.13855 12.648 7.36625 12.8837L9.86625 15.3837C10.1007 15.6181 10.4185 15.7497 10.75 15.7497C11.0815 15.7497 11.3993 15.6181 11.6337 15.3837L16.6337 10.3837Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  ExternalLink: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.875 14.5H17.625C17.4592 14.5 17.3003 14.5658 17.1831 14.6831C17.0658 14.8003 17 14.9592 17 15.125V19.5H4.5V7H10.125C10.2908 7 10.4497 6.93415 10.5669 6.81694C10.6842 6.69973 10.75 6.54076 10.75 6.375V5.125C10.75 4.95924 10.6842 4.80027 10.5669 4.68306C10.4497 4.56585 10.2908 4.5 10.125 4.5H3.875C3.37772 4.5 2.90081 4.69754 2.54917 5.04917C2.19754 5.40081 2 5.87772 2 6.375L2 20.125C2 20.6223 2.19754 21.0992 2.54917 21.4508C2.90081 21.8025 3.37772 22 3.875 22H17.625C18.1223 22 18.5992 21.8025 18.9508 21.4508C19.3025 21.0992 19.5 20.6223 19.5 20.125V15.125C19.5 14.9592 19.4342 14.8003 19.3169 14.6831C19.1997 14.5658 19.0408 14.5 18.875 14.5ZM21.0625 2H16.0625C15.2277 2 14.8105 3.01211 15.3984 3.60156L16.7941 4.99727L7.27344 14.5145C7.18604 14.6016 7.11669 14.705 7.06937 14.819C7.02206 14.933 6.9977 15.0551 6.9977 15.1785C6.9977 15.3019 7.02206 15.4241 7.06937 15.538C7.11669 15.652 7.18604 15.7555 7.27344 15.8426L8.15898 16.7266C8.24608 16.814 8.34957 16.8833 8.46353 16.9306C8.57748 16.9779 8.69966 17.0023 8.82305 17.0023C8.94643 17.0023 9.06861 16.9779 9.18256 16.9306C9.29652 16.8833 9.40001 16.814 9.48711 16.7266L19.0031 7.20781L20.3984 8.60156C20.9844 9.1875 22 8.77734 22 7.9375V2.9375C22 2.68886 21.9012 2.4504 21.7254 2.27459C21.5496 2.09877 21.3111 2 21.0625 2V2Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Folder: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7.2998C2 6.63676 2.26339 6.00088 2.73223 5.53204C3.20107 5.0632 3.83696 4.7998 4.5 4.7998H10.75L13.25 7.2998H19.5C20.163 7.2998 20.7989 7.5632 21.2678 8.03204C21.7366 8.50088 22 9.13676 22 9.79981V17.2998C22 17.9628 21.7366 18.5987 21.2678 19.0676C20.7989 19.5364 20.163 19.7998 19.5 19.7998H4.5C3.83696 19.7998 3.20107 19.5364 2.73223 19.0676C2.26339 18.5987 2 17.9628 2 17.2998V7.2998Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Home: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8857 2.36636C12.6509 2.13166 12.3325 1.99982 12.0005 1.99982C11.6686 1.99982 11.3502 2.13166 11.1154 2.36636L2.35198 11.1298C2.12393 11.3659 1.99774 11.6822 2.0006 12.0104C2.00345 12.3387 2.13511 12.6527 2.36723 12.8848C2.59935 13.1169 2.91334 13.2486 3.24159 13.2514C3.56984 13.2543 3.88608 13.1281 4.1222 12.9L4.48901 12.5332V20.7784C4.48901 21.1104 4.62091 21.4289 4.85569 21.6636C5.09047 21.8984 5.4089 22.0303 5.74093 22.0303H8.24478C8.57681 22.0303 8.89524 21.8984 9.13002 21.6636C9.3648 21.4289 9.4967 21.1104 9.4967 20.7784V18.2745C9.4967 17.9425 9.6286 17.6241 9.86338 17.3893C10.0982 17.1545 10.4166 17.0226 10.7486 17.0226H13.2525C13.5845 17.0226 13.9029 17.1545 14.1377 17.3893C14.3725 17.6241 14.5044 17.9425 14.5044 18.2745V20.7784C14.5044 21.1104 14.6363 21.4289 14.8711 21.6636C15.1059 21.8984 15.4243 22.0303 15.7563 22.0303H18.2602C18.5922 22.0303 18.9106 21.8984 19.1454 21.6636C19.3802 21.4289 19.5121 21.1104 19.5121 20.7784V12.5332L19.8789 12.9C20.115 13.1281 20.4313 13.2543 20.7595 13.2514C21.0878 13.2486 21.4018 13.1169 21.6339 12.8848C21.866 12.6527 21.9977 12.3387 22.0005 12.0104C22.0034 11.6822 21.8772 11.3659 21.6491 11.1298L12.8857 2.36636Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Back: (props: any) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#DAE0E7" />
      <path
        d="M7.9129 9.9999L10.3629 12.4499C10.4629 12.5499 10.5108 12.6666 10.5066 12.7999C10.5025 12.9332 10.4504 13.0499 10.3504 13.1499C10.2504 13.2416 10.1337 13.2895 9.9999 13.2936C9.8666 13.2977 9.7504 13.2499 9.6504 13.1499L6.3504 9.8499C6.3004 9.7999 6.2649 9.7457 6.2441 9.6874C6.2233 9.6291 6.2129 9.5666 6.2129 9.4999C6.2129 9.4332 6.2233 9.3707 6.2441 9.3124C6.2649 9.2541 6.3004 9.1999 6.3504 9.1499L9.6504 5.8499C9.7421 5.7582 9.8566 5.7124 9.9941 5.7124C10.1316 5.7124 10.2504 5.7582 10.3504 5.8499C10.4504 5.9499 10.5004 6.0686 10.5004 6.2061C10.5004 6.3436 10.4504 6.4624 10.3504 6.5624L7.9129 8.9999H13.5004C13.6421 8.9999 13.7608 9.0477 13.8566 9.1436C13.9525 9.2395 14.0004 9.3582 14.0004 9.4999C14.0004 9.6416 13.9525 9.7603 13.8566 9.8561C13.7608 9.952 13.6421 9.9999 13.5004 9.9999H7.9129Z"
        fill="#808998"
        {...props}
      />
    </svg>
  ),
  ChevronLeft: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.9884 5.41005C15.5351 5.95679 15.5351 6.84321 14.9884 7.38995L10.3783 12L14.9884 16.6101C15.5351 17.1568 15.5351 18.0432 14.9884 18.5899C14.4417 19.1367 13.5552 19.1367 13.0085 18.5899L7.40849 12.99C6.86175 12.4432 6.86175 11.5568 7.40849 11.0101L13.0085 5.41005C13.5552 4.86332 14.4417 4.86332 14.9884 5.41005Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  ChevronRight: (props: any) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.707 17.293a1 1 0 010-1.414L11.586 12 7.707 8.121a1 1 0 011.414-1.414L14.707 12l-5.586 5.586a1 1 0 01-1.414 0z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  CloudUpload: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.4 20.8C2.41763 20.8 0 18.3812 0 15.4C0 13.045 1.50637 11.0425 3.6075 10.3038C3.60263 10.2025 3.6 10.1012 3.6 10C3.6 6.685 6.285 4 9.6 4C11.8238 4 13.7625 5.20937 14.8013 7.0075C15.3713 6.59125 16.0613 6.4 16.8 6.4C18.7875 6.4 20.4 7.97875 20.4 10C20.4 10.4575 20.3137 10.8925 20.16 11.2975C22.35 11.74 24 13.6787 24 16C24 18.6512 21.8513 20.8 19.2 20.8H5.4ZM8.3625 12.6625C8.01375 13.015 8.01375 13.585 8.3625 13.9037C8.715 14.2862 9.285 14.2862 9.60375 13.9037L11.1 12.4712V17.5C11.1 17.9987 11.5013 18.4 12 18.4C12.4988 18.4 12.9 17.9987 12.9 17.5V12.4712L14.3625 13.9037C14.715 14.2862 15.285 14.2862 15.6038 13.9037C15.9863 13.585 15.9863 13.015 15.6038 12.6625L12.6038 9.6625C12.285 9.31375 11.715 9.31375 11.3625 9.6625L8.3625 12.6625Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Slider: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6V4M12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10M12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10M6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14M6 18C4.89543 18 4 17.1046 4 16C4 14.8954 4.89543 14 6 14M6 18V20M6 14V4M12 10V20M18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14M18 18C16.8954 18 16 17.1046 16 16C16 14.8954 16.8954 14 18 14M18 18V20M18 14V4"
        stroke="#A1A1AA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
    </svg>
  ),
  Menu: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15Z"
        fill="#A1A1AA"
        {...props}
      />
      <path
        d="M19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
        fill="#A1A1AA"
        {...props}
      />
      <path
        d="M19 7H5C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9H19C19.5523 9 20 8.55228 20 8C20 7.44772 19.5523 7 19 7Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Trash: (props: any) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 4.99935H4.16667M4.16667 4.99935H17.5M4.16667 4.99935L4.16667 16.666C4.16667 17.108 4.34226 17.532 4.65482 17.8445C4.96738 18.1571 5.39131 18.3327 5.83333 18.3327H14.1667C14.6087 18.3327 15.0326 18.1571 15.3452 17.8445C15.6577 17.532 15.8333 17.108 15.8333 16.666V4.99935M6.66667 4.99935V3.33268C6.66667 2.89065 6.84226 2.46673 7.15482 2.15417C7.46738 1.84161 7.89131 1.66602 8.33333 1.66602H11.6667C12.1087 1.66602 12.5326 1.84161 12.8452 2.15417C13.1577 2.46673 13.3333 2.89065 13.3333 3.33268V4.99935"
        stroke={"#9CA3AF"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
    </svg>
  ),
  Play: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 22C17.4706 22 22 17.4608 22 12C22 6.52941 17.4608 2 11.9902 2C6.52941 2 2 6.52941 2 12C2 17.4608 6.53922 22 12 22ZM12 20.3333C7.37255 20.3333 3.67647 16.6275 3.67647 12C3.67647 7.37255 7.36275 3.66667 11.9902 3.66667C16.6176 3.66667 20.3235 7.37255 20.3333 12C20.3431 16.6275 16.6275 20.3333 12 20.3333ZM15.7451 12.5392C16.1569 12.2941 16.1471 11.7255 15.7451 11.4902L10.1667 8.18628C9.7451 7.93137 9.18628 8.12745 9.18628 8.59804V15.4216C9.18628 15.8922 9.70588 16.1078 10.1667 15.8333L15.7451 12.5392Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Download: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.59998 5.99999C3.59998 4.67451 4.67449 3.59999 5.99998 3.59999H7.19998C7.86272 3.59999 8.39998 4.13725 8.39998 4.79999C8.39998 5.46274 7.86272 5.99999 7.19998 5.99999L5.99998 5.99999V18H18V5.99999H16.8C16.1372 5.99999 15.6 5.46274 15.6 4.79999C15.6 4.13725 16.1372 3.59999 16.8 3.59999H18C19.3255 3.59999 20.4 4.67451 20.4 5.99999V18C20.4 19.3255 19.3255 20.4 18 20.4H5.99998C4.67449 20.4 3.59998 19.3255 3.59998 18V5.99999Z"
        fill="#A1A1AA"
        {...props}
      />
      <path
        d="M4.79998 14.4H8.39998L9.59998 16.8H14.4L15.6 14.4H19.2V19.2H4.79998V14.4Z"
        fill="#A1A1AA"
        {...props}
      />
      <path
        d="M8.75145 8.75147C9.22008 8.28284 9.97987 8.28284 10.4485 8.75147L10.8 9.10294V3.59999C10.8 2.93725 11.3372 2.39999 12 2.39999C12.6627 2.39999 13.2 2.93725 13.2 3.59999V9.10294L13.5514 8.75147C14.0201 8.28284 14.7799 8.28284 15.2485 8.75147C15.7171 9.2201 15.7171 9.97989 15.2485 10.4485L12.8485 12.8485C12.6235 13.0736 12.3182 13.2 12 13.2C11.6817 13.2 11.3765 13.0736 11.1514 12.8485L8.75145 10.4485C8.28282 9.97989 8.28282 9.2201 8.75145 8.75147Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Edit: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.8968 3.1032C20.4468 2.65327 19.8364 2.40051 19.2 2.40051C18.5636 2.40051 17.9533 2.65327 17.5032 3.1032L8.40002 12.2064V15.6H11.7936L20.8968 6.4968C21.3468 6.04673 21.5995 5.43639 21.5995 4.8C21.5995 4.16361 21.3468 3.55327 20.8968 3.1032Z"
        fill="#A1A1AA"
        {...props}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.40002 7.19999C2.40002 6.56347 2.65288 5.95302 3.10297 5.50293C3.55306 5.05284 4.1635 4.79999 4.80002 4.79999H9.60002C9.91828 4.79999 10.2235 4.92642 10.4486 5.15146C10.6736 5.3765 10.8 5.68173 10.8 5.99999C10.8 6.31825 10.6736 6.62347 10.4486 6.84852C10.2235 7.07356 9.91828 7.19999 9.60002 7.19999H4.80002V19.2H16.8V14.4C16.8 14.0817 16.9265 13.7765 17.1515 13.5515C17.3765 13.3264 17.6818 13.2 18 13.2C18.3183 13.2 18.6235 13.3264 18.8486 13.5515C19.0736 13.7765 19.2 14.0817 19.2 14.4V19.2C19.2 19.8365 18.9472 20.447 18.4971 20.897C18.047 21.3471 17.4365 21.6 16.8 21.6H4.80002C4.1635 21.6 3.55306 21.3471 3.10297 20.897C2.65288 20.447 2.40002 19.8365 2.40002 19.2V7.19999Z"
        fill="#A1A1AA"
        {...props}
      />
    </svg>
  ),
  Error: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_1_4336)">
        <path
          d="M8.20312 8.20312C8.64375 7.76719 9.35625 7.76719 9.75469 8.20312L11.9578 10.4109L14.2031 8.20312C14.6438 7.76719 15.3563 7.76719 15.7547 8.20312C16.2328 8.64375 16.2328 9.35625 15.7547 9.75469L13.5891 11.9578L15.7547 14.2031C16.2328 14.6438 16.2328 15.3563 15.7547 15.7547C15.3563 16.2328 14.6438 16.2328 14.2031 15.7547L11.9578 13.5891L9.75469 15.7547C9.35625 16.2328 8.64375 16.2328 8.20312 15.7547C7.76719 15.3563 7.76719 14.6438 8.20312 14.2031L10.4109 11.9578L8.20312 9.75469C7.76719 9.35625 7.76719 8.64375 8.20312 8.20312ZM24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12ZM12 2.25C6.61406 2.25 2.25 6.61406 2.25 12C2.25 17.3859 6.61406 21.75 12 21.75C17.3859 21.75 21.75 17.3859 21.75 12C21.75 6.61406 17.3859 2.25 12 2.25Z"
          fill="#A1A1AA"
          {...props}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_4336">
          <rect width="24" height="24" fill="white" {...props} />
        </clipPath>
      </defs>
    </svg>
  ),
  Microsoft: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="11" height="11" fill="#DD512F" />
      <rect x="12.5" y="0.5" width="11" height="11" fill="#81AE31" />
      <rect x="0.5" y="12.5" width="11" height="11" fill="#3C99E6" />
      <rect x="12.5" y="12.5" width="11" height="11" fill="#F5B139" />
    </svg>
  ),
  CancelCircle: (props: any) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99984 11.1665L12.4165 13.5832C12.5693 13.7359 12.7637 13.8123 12.9998 13.8123C13.2359 13.8123 13.4304 13.7359 13.5832 13.5832C13.7359 13.4304 13.8123 13.2359 13.8123 12.9998C13.8123 12.7637 13.7359 12.5693 13.5832 12.4165L11.1665 9.99984L13.5832 7.58317C13.7359 7.43039 13.8123 7.23595 13.8123 6.99984C13.8123 6.76373 13.7359 6.56928 13.5832 6.4165C13.4304 6.26373 13.2359 6.18734 12.9998 6.18734C12.7637 6.18734 12.5693 6.26373 12.4165 6.4165L9.99984 8.83317L7.58317 6.4165C7.43039 6.26373 7.23595 6.18734 6.99984 6.18734C6.76373 6.18734 6.56928 6.26373 6.4165 6.4165C6.26373 6.56928 6.18734 6.76373 6.18734 6.99984C6.18734 7.23595 6.26373 7.43039 6.4165 7.58317L8.83317 9.99984L6.4165 12.4165C6.26373 12.5693 6.18734 12.7637 6.18734 12.9998C6.18734 13.2359 6.26373 13.4304 6.4165 13.5832C6.56928 13.7359 6.76373 13.8123 6.99984 13.8123C7.23595 13.8123 7.43039 13.7359 7.58317 13.5832L9.99984 11.1665ZM9.99984 18.3332C8.84706 18.3332 7.76373 18.1144 6.74984 17.6769C5.73595 17.2394 4.854 16.6457 4.104 15.8957C3.354 15.1457 2.76025 14.2637 2.32275 13.2498C1.88525 12.2359 1.6665 11.1526 1.6665 9.99984C1.6665 8.84706 1.88525 7.76373 2.32275 6.74984C2.76025 5.73595 3.354 4.854 4.104 4.104C4.854 3.354 5.73595 2.76025 6.74984 2.32275C7.76373 1.88525 8.84706 1.6665 9.99984 1.6665C11.1526 1.6665 12.2359 1.88525 13.2498 2.32275C14.2637 2.76025 15.1457 3.354 15.8957 4.104C16.6457 4.854 17.2394 5.73595 17.6769 6.74984C18.1144 7.76373 18.3332 8.84706 18.3332 9.99984C18.3332 11.1526 18.1144 12.2359 17.6769 13.2498C17.2394 14.2637 16.6457 15.1457 15.8957 15.8957C15.1457 16.6457 14.2637 17.2394 13.2498 17.6769C12.2359 18.1144 11.1526 18.3332 9.99984 18.3332Z"
        fill="#DB554D"
        {...props}
      />
    </svg>
  ),
  CheckCircle: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5995 16.6L17.6495 9.55L16.2495 8.15L10.5995 13.8L7.74951 10.95L6.34951 12.35L10.5995 16.6ZM11.9995 22C10.6162 22 9.31618 21.7375 8.09951 21.2125C6.88284 20.6875 5.82451 19.975 4.92451 19.075C4.02451 18.175 3.31201 17.1167 2.78701 15.9C2.26201 14.6833 1.99951 13.3833 1.99951 12C1.99951 10.6167 2.26201 9.31667 2.78701 8.1C3.31201 6.88333 4.02451 5.825 4.92451 4.925C5.82451 4.025 6.88284 3.3125 8.09951 2.7875C9.31618 2.2625 10.6162 2 11.9995 2C13.3828 2 14.6828 2.2625 15.8995 2.7875C17.1162 3.3125 18.1745 4.025 19.0745 4.925C19.9745 5.825 20.687 6.88333 21.212 8.1C21.737 9.31667 21.9995 10.6167 21.9995 12C21.9995 13.3833 21.737 14.6833 21.212 15.9C20.687 17.1167 19.9745 18.175 19.0745 19.075C18.1745 19.975 17.1162 20.6875 15.8995 21.2125C14.6828 21.7375 13.3828 22 11.9995 22Z"
        fill="#2BB9CD"
        {...props}
      />
    </svg>
  ),
  Bell: (props: any) => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.0002 29C17.4668 29 18.6668 27.8 18.6668 26.3333H13.3335C13.3335 27.8 14.5202 29 16.0002 29ZM24.0002 21V14.3333C24.0002 10.24 21.8135 6.81333 18.0002 5.90667V5C18.0002 3.89333 17.1068 3 16.0002 3C14.8935 3 14.0002 3.89333 14.0002 5V5.90667C10.1735 6.81333 8.00016 10.2267 8.00016 14.3333V21L5.3335 23.6667V25H26.6668V23.6667L24.0002 21Z"
        fill="#D8E0E9"
        {...props}
      />
    </svg>
  ),
  MagnifyingGlass: (props: any) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="search_FILL0_wght400_GRAD0_opsz24 1">
        <path
          id="Vector"
          d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"
          fill="#223C69"
          {...props}
        />
      </g>
    </svg>
  ),
};
export const QoosIconWithShadow = (props?: any) => {
  return (
    <div
      className={`rounded-full w-[90px] h-[70px] shadow-lg ${props.divProps}`}
    >
      <svg
        width="90"
        height="96"
        viewBox="0 0 90 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props?.svgProps}
      >
        <rect
          x="2.77778"
          y="2.77778"
          width="84.4444"
          height="84.4444"
          rx="42.2222"
          fill="url(#paint0_linear_4689_17064)"
        />
        <rect
          x="2.77778"
          y="2.77778"
          width="84.4444"
          height="84.4444"
          rx="42.2222"
          fill="url(#paint1_radial_4689_17064)"
        />
        <rect
          x="2.77778"
          y="2.77778"
          width="84.4444"
          height="84.4444"
          rx="42.2222"
          stroke="white"
          stroke-width="4.44444"
        />
        <g filter="url(#filter0_dddd_4689_17064)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.2218 44.9996C67.2218 51.3818 64.5313 57.1357 60.2226 61.1888L66.2556 67.2218H44.5165V67.2166C32.4665 66.9596 22.7773 57.1111 22.7773 44.9996C22.7773 32.7266 32.7266 22.7773 44.9996 22.7773C57.2726 22.7773 67.2218 32.7266 67.2218 44.9996ZM58.5258 44.9992C58.5258 50.1004 55.702 54.5421 51.5323 56.8464L53.2118 58.5258H44.9992C37.5287 58.5258 31.4727 52.4698 31.4727 44.9992C31.4727 37.5287 37.5287 31.4727 44.9992 31.4727C52.4697 31.4727 58.5258 37.5287 58.5258 44.9992Z"
            fill="#565ADD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.2218 44.9996C67.2218 51.3818 64.5313 57.1357 60.2226 61.1888L66.2556 67.2218H44.5165V67.2166C32.4665 66.9596 22.7773 57.1111 22.7773 44.9996C22.7773 32.7266 32.7266 22.7773 44.9996 22.7773C57.2726 22.7773 67.2218 32.7266 67.2218 44.9996ZM58.5258 44.9992C58.5258 50.1004 55.702 54.5421 51.5323 56.8464L53.2118 58.5258H44.9992C37.5287 58.5258 31.4727 52.4698 31.4727 44.9992C31.4727 37.5287 37.5287 31.4727 44.9992 31.4727C52.4697 31.4727 58.5258 37.5287 58.5258 44.9992Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_dddd_4689_17064"
            x="12.9996"
            y="21.444"
            width="60.4453"
            height="73.7786"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.33333" />
            <feGaussianBlur stdDeviation="1.33333" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4689_17064"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-0.444444" dy="4.88889" />
            <feGaussianBlur stdDeviation="2.44444" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_4689_17064"
              result="effect2_dropShadow_4689_17064"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-0.888889" dy="11.1111" />
            <feGaussianBlur stdDeviation="3.33333" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_4689_17064"
              result="effect3_dropShadow_4689_17064"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-1.77778" dy="20" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_4689_17064"
              result="effect4_dropShadow_4689_17064"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect4_dropShadow_4689_17064"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_4689_17064"
            x1="45"
            y1="36.875"
            x2="45"
            y2="85"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop offset="1" stop-color="#EAEAEB" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_4689_17064"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(45 19.2222) rotate(90) scale(161.333)"
          >
            <stop stop-color="#6E73F8" />
            <stop offset="1" stop-color="#0D0F4F" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};
